import React from 'react';
import {withTranslation} from 'react-i18next';
import {Field, Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import TextField from '../components/TextField';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {NotificationManager} from "../components/common/react-notifications";
import {isEqual, find} from 'lodash';
import Switch from 'react-switch';
import Api from "../services/Api";
import {required} from "../helpers/Validators";
import FieldError from "../components/FieldError";
import {store} from "../AppRenderer";
import Select from "react-select";

class ZoneManageForm extends React.Component {
  constructor(props) {
    super(props);
    this.pairOptions = store.getState().general.pairs.map(pair => ({
      label: pair.name, value: pair.name
    }));
  }

  addZone = async values => {
    const {t, afterSubmit} = this.props;
    const {name, pairs, enabled, fa, en} = values;
    try {
      await Api.invoke(
        'POST',
        '/v2/admin-ui/zones',
        {
          name: String(name).toUpperCase(),
          pairs: pairs.map(item => item.value),
          labels: [
            {language: "fa", value: fa},
            {language: "en", value: en},
          ],
          enabled,
        },
      );
      NotificationManager.success(t('New zone added successfully'), t('Message'));
      afterSubmit();
      ModalManager.close({
        isOpen: false
      });
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  updateZone = async values => {
    const {t, zone, afterSubmit} = this.props;
    const {name, pairs, enabled, fa, en} = values;
    const newValues = {
      name: String(name).toUpperCase(),
      pairs: pairs.map(item => item.value),
      labels: [
        {language: "fa", value: fa},
        {language: "en", value: en},
      ],
      enabled,
    };
    try {
      await Api.invoke(
        'PATCH',
        `/v2/admin-ui/zones/${zone.id}`,
        newValues
      );
      NotificationManager.success(t('Zone {{name}} updated successfully', {name}), t('Message'));
      afterSubmit();
      ModalManager.close({
        isOpen: false
      });
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  ReactSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      isMulti
      placeholder={this.props.t('Select')}
      closeMenuOnSelect={false}
    />
  );

  render() {
    const {t, zone} = this.props;
    return(
      <FinalForm
        initialValues={{
          name: zone ? zone.name : undefined,
          pairs: zone ? zone.pairs.map(item => ({label: item, value: item})) : undefined,
          enabled: zone ? zone.enabled : undefined,
          fa: zone ? find(zone.labels, {language: 'fa'}).value : undefined,
          en: zone ? find(zone.labels, {language: 'en'}).value : undefined,
        }}
        onSubmit={zone ? this.updateZone : this.addZone}
        render={({handleSubmit, submitting, hasValidationErrors, values, initialValues}) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row className="mb-2">
                <Col>
                  <TextField
                    item={{
                      name: 'name',
                      i18n: t('Zone name'),
                      type: 'text',
                      required: true,
                    }}
                  />
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col>
                  <TextField item={{
                    name: 'fa',
                    i18n: t('Farsi Name'),
                    type: 'text',
                    required: true,
                  }}/>
                </Col>
                <Col>
                  <TextField item={{
                    name: 'en',
                    i18n: t('English Name'),
                    type: 'text',
                    required: true,
                  }}/>
                </Col>
              </Row>
              <Row className="mb-4">
                <Col>
                  <span>
                   {t('pairs')}
                   <span className="required">*</span>
                  </span>
                  <Field
                    name="pairs"
                    component={this.ReactSelectAdapter}
                    options={this.pairOptions}
                    validate={required}
                  />
                  <FieldError name='tokens' />
                </Col>
              </Row>
              <Field name='enabled'>
                {({input}) => (
                  <Row className="align-items-center mb-3">
                    <Switch
                      className="mx-3 ltr"
                      onChange={enabled => {input.onChange(enabled);}}
                      checked={input.value}
                      height={24}
                      width={45}
                    />
                    <span className={`mx-2 ${input.value ? 'text-success' : 'text-danger'}`}>
                      {t('Status')} {input.value ? t('Enabled') : t('Disabled')}
                    </span>
                  </Row>
                )}
              </Field>
              <Row className='mt-5'>
                <Col>
                  <LoaderButton
                    color="success"
                    className="text-center"
                    loading={submitting}
                    onClick={handleSubmit}
                    style={{minWidth: '100px'}}
                    disabled={hasValidationErrors || submitting || isEqual(values, initialValues)}>
                    {zone ? t('Update') : t('Submit')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(ZoneManageForm);
